// extracted by mini-css-extract-plugin
export default {"stat":"stat-84dd"};